import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_PROJECT, ADD_PROJECT_FAILED, ADD_PROJECT_FILES, ADD_PROJECT_FILES_FAILED, ADD_PROJECT_FILES_SUCCESS, ADD_PROJECT_MILESTONES, ADD_PROJECT_MILESTONES_FAILED, ADD_PROJECT_MILESTONES_SUCCESS, ADD_PROJECT_SUCCESS, DELETE_PROJECT_MILESTONES, DELETE_PROJECT_MILESTONES_FAILED, DELETE_PROJECT_MILESTONES_SUCCESS, PROJECT, PROJECT_FAILED, PROJECT_FILES, PROJECT_FILES_FAILED, PROJECT_FILES_SUCCESS, PROJECT_MILESTONES, PROJECT_MILESTONES_FAILED, PROJECT_MILESTONES_SUCCESS, PROJECT_SUCCESS, UPDATE_PROJECT, UPDATE_PROJECT_FAILED, UPDATE_PROJECT_MILESTONES, UPDATE_PROJECT_MILESTONES_FAILED, UPDATE_PROJECT_MILESTONES_SUCCESS, UPDATE_PROJECT_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getprojects = () => async (dispatch) => {
  dispatch({
    type: PROJECT,
  });
  try {
    let response = await api(`project/projectList`, "get", {}, getAuthHeader());
    dispatch({
      type: PROJECT_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching project list error ====>", error);
    return dispatch({
      type: PROJECT_FAILED,
      payload: error?.message,
    });
  }
};

export const addProject = (data) => async dispatch => {
  dispatch({
    type: ADD_PROJECT
  })
  try {
    let response = await api(`project/add`, 'post', data, getAuthHeader())
    console.log('add Project data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_PROJECT_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding Project error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_PROJECT_FAILED,
      payload: error?.message
    })
  }
}

export const updateProject = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_PROJECT
  })
  try {
    let response = await api(`project/update/${id}`, 'put', data, getAuthHeader())
    console.log('update Project data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_PROJECT_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating Project error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_PROJECT_FAILED,
      payload: error?.message
    })
  }
}

export const getProjectFiles = () => async (dispatch) => {
  dispatch({
    type: PROJECT_FILES,
  });
  try {
    let response = await api(`project/projectFiles`, "get", {}, getAuthHeader());
    dispatch({
      type: PROJECT_FILES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching project files error ====>", error);
    return dispatch({
      type: PROJECT_FILES_FAILED,
      payload: error?.message,
    });
  }
};

export const addProjectFile = (data) => async dispatch => {
  dispatch({
    type: ADD_PROJECT_FILES
  })
  try {
    let response = await api(`project/addProjectFile`, 'post', data, getAuthHeader())
    console.log('add Project file data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_PROJECT_FILES_SUCCESS,
      payload: response?.data
    })
    await dispatch(getProjectFiles());

    return response
  } catch (error) {
    console.log("while Adding Project file error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_PROJECT_FILES_FAILED,
      payload: error?.message
    })
  }
}

export const getProjectMilestones = () => async (dispatch) => {
  dispatch({
    type: PROJECT_MILESTONES,
  });
  try {
    let response = await api(`project/projectMilestones`, "get", {}, getAuthHeader());
    dispatch({
      type: PROJECT_MILESTONES_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching project milestones error ====>", error);
    return dispatch({
      type: PROJECT_MILESTONES_FAILED,
      payload: error?.message,
    });
  }
};

export const addProjectMilestones = (data) => async dispatch => {
  dispatch({
    type: ADD_PROJECT_MILESTONES
  })
  try {
    let response = await api(`project/addProjectMilestones`, 'post', data, getAuthHeader())
    console.log('add Project milestones data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_PROJECT_MILESTONES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding Project milestones error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_PROJECT_MILESTONES_FAILED,
      payload: error?.message
    })
  }
}

export const updateProjectMilestones = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_PROJECT_MILESTONES
  })
  try {
    let response = await api(`project/updateProjectMilestones/${id}`, 'put', data, getAuthHeader())
    console.log('update Project milestones data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_PROJECT_MILESTONES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating Project milestones error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_PROJECT_MILESTONES_FAILED,
      payload: error?.message
    })
  }
}

export const deleteProjectMilestones = (id) => async dispatch => {
  dispatch({
    type: DELETE_PROJECT_MILESTONES
  })
  try {
    let response = await api(`project/deleteProjectMilestones/${id}`, 'delete', {}, getAuthHeader())
    console.log('deleted project milestones data', response);
    toast.success("Deleted Successfully");
    dispatch({
      type: DELETE_PROJECT_MILESTONES_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while deleting project milestones error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: DELETE_PROJECT_MILESTONES_FAILED,
      payload: error?.message
    })
  }
}